import { useQuery } from "@tanstack/react-query";
import { plantoesApi } from "../api/plantoesApi";

// `options` repassa opções do react-query (ex.: `enabled` para só buscar quando a tela
// que usa a lista estiver visível).
export function usePlantoesQuery(filtros = {}, options = {}) {
  return useQuery({
    queryKey: ["plantoes", filtros],
    queryFn: () => plantoesApi.list(filtros),
    ...options,
  });
}
